import { createTheme } from "@mui/material/styles";

const obi = {
  navy: "#01415B",
  navyDeep: "#0D2A4F",
  sage: "#3F6B5B",
  sageHover: "#4D7867",
  blue: "#048ABF",
  blueText: "#02729F",
  yellow: "#FAB935",
  gold: "#CCA76F",
  bg: "#F3F6FC",
  surface: "#FFFFFF",
  cream: "#EEEFE9",
  ink: "#222222",
  inkSoft: "#232222",
  border: "#DFDFDF",
  borderSoft: "#E3E7EE",
  muted: "#B6B6B6",
};

export const lightTheme = createTheme({
  // body: {
  //   backgroundColor: "#F2F2F2 !important",
  //   color: "#4c5b5c"
  // },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: ({ theme }) => ({
          "&.Mui-disabled": {
            opacity: 1,
            "-webkit-text-fill-color": theme.palette.grey.dark+' !important',
            pointerEvents: "auto"
          }
        })
      }
    }
  },
  typography: {
   fontFamily: `futura-pt, "Helvetica", "Arial", sans-serif`,
   fontSize: 16,
   // "fontWeightLight": 300,
   // "fontWeightRegular": 400,
   // "fontWeightMedium": 500
  },
  paper: {
    root: {
      borderRadius: '15px',
    },
  },
  palette: {
    mode: 'light',
    type: 'light',
    obi,
    common: {
      black: '#000',
      grey: obi.muted,
      green: '#2ecc71',
      white: obi.surface
    },
    primary: {
      light: obi.blue,
      main: obi.navy,
      dark: obi.navyDeep,
      darker: obi.navyDeep,
      contrastText: obi.cream,
    },
    secondary: {
      light: '#AD5D5D',
      main: '#A65353',
      dark: '#884343',
      contrastText: obi.surface,
    },
    error: {
      lighter: '#ed9e9e',
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      light: obi.yellow,
      main: obi.yellow,
      dark: obi.gold,
      contrastText: obi.ink,
    },
    info: {
      light: obi.blue,
      main: obi.blueText,
      dark: obi.navy,
      contrastText: '#fff',
    },
    grey: {
      light: obi.inkSoft,
      main: obi.ink,
      dark: obi.ink,
      darkest: obi.ink,
      contrastText: '#fff',
    },
    ltgrey: {
      light: obi.borderSoft,
      main: obi.border,
      dark: obi.muted,
      contrastText: '#000',
    },
    employ: {
      light: obi.borderSoft,
      main: obi.blue,
      dark: obi.navy,
      contrastText: '#fff',
    },
    incorp: {
      light: obi.cream,
      main: obi.yellow,
      dark: obi.gold,
      contrastText: obi.ink,
    },
    ltblue: {
      main: obi.blue,
      contrastText: obi.surface,
    },
    bgblue: {
      main: obi.bg,
      contrastText: '#000',
    },
    bggrey: {
      main: obi.surface,
      contrastText: '#000',
    },
    tablehead: {
      main: obi.surface,
      contrastText: obi.ink,
    },
    tablerow: {
      main: obi.bg,
      dark: obi.border,
      contrastText: obi.ink,
    },
    tablerowalt: {
      main: obi.borderSoft,
      contrastText: obi.ink,
    },
    appBar: {
      main: obi.surface,
      contrastText: obi.navy,
    },
    drawer: {
      main: obi.navyDeep,
      contrastText: obi.cream
    },
    drawerId: {
      hover: 'rgba(238, 239, 233, 0.12)',
      main: 'rgba(238, 239, 233, 0.07)',
      contrastText: obi.cream
    },
    drawerNav: {
      hover: 'rgba(238, 239, 233, 0.10)',
      main: 'rgba(238, 239, 233, 0.06)',
      accent: obi.yellow,
      contrastText: obi.cream
    },
    drawerLogo: {
      main: obi.surface,
    },
    orange: {
      main: obi.yellow,
      contrastText: obi.ink,
    },
    success: {
      main: '#2ecc71',
      dark: '#2abc68',
      darker: '#208c4e',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: obi.surface,
      default: obi.bg,
      //appBar: '#fff',
      //drawer: '#0068a8',
      //drawerId: '#00588e',
      contrastText: obi.ink,
    },
    text: {
      primary: obi.ink,
      secondary: obi.inkSoft,
      disabled: obi.muted,
    },
    divider: obi.borderSoft,
    action: {

    }
  },
});

export const darkTheme = createTheme({
  // body: {
  //   backgroundColor: "#333333 !important",
  //   color: "#fff"
  // },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: ({ theme }) => ({
          "&.Mui-disabled": {
            opacity: 1,
            "-webkit-text-fill-color": theme.palette.grey.light+' !important',
            pointerEvents: "auto"
          }
        })
      }
    }
  },
  typography: {
   fontFamily: `futura-pt, "Helvetica", "Arial", sans-serif`,
   fontSize: 16,
   // "fontWeightLight": 300,
   // "fontWeightRegular": 400,
   // "fontWeightMedium": 500
  },
  palette: {
    mode: 'dark',
    type: 'dark',
    obi,
    common: {
      black: '#000',
      grey: obi.muted,
      green: '#2ecc71',
      white: obi.surface
    },
    primary: {
      light: '#8CCCEB',
      main: '#63B6DC',
      dark: '#48A2CB',
      darker: obi.blueText,
      contrastText: obi.ink,
    },
    secondary: {
      light: '#AD5D5D',
      main: '#A65353',
      dark: '#884343',
      contrastText: obi.surface,
    },
    error: {
      lighter: '#ed9e9e',
      light: '#e57373',
      main: '#e57373',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      light: obi.yellow,
      main: obi.yellow,
      dark: obi.gold,
      contrastText: obi.ink,
    },
    info: {
      light: obi.blue,
      main: obi.blueText,
      dark: obi.blue,
      contrastText: obi.surface,
    },
    grey: {
      light: obi.cream,
      main: obi.border,
      dark: obi.muted,
      darkest: obi.surface,
      contrastText: '#fff',
    },
    ltgrey: {
      light: obi.borderSoft,
      main: obi.border,
      dark: obi.muted,
      contrastText: '#fff',
    },
    employ: {
      light: obi.borderSoft,
      main: obi.blue,
      dark: obi.navy,
      contrastText: '#fff',
    },
    incorp: {
      light: obi.cream,
      main: obi.yellow,
      dark: obi.gold,
      contrastText: obi.ink,
    },
    ltblue: {
      main: obi.blue,
      contrastText: obi.surface,
    },
    bgblue: {
      main: '#383838',
      contrastText: obi.cream,
    },
    bggrey: {
      main: '#323232',
      contrastText: obi.cream,
    },
    tablehead: {
      main: '#3C3C3C',
      contrastText: obi.cream,
    },
    tablerow: {
      main: '#323232',
      dark: '#444444',
      contrastText: obi.cream,
    },
    tablerowalt: {
      main: '#383838',
      contrastText: obi.cream,
    },
    appBar: {
      main: '#303030',
      contrastText: obi.cream
    },
    drawer: {
      main: '#2C2C2C',
      contrastText: obi.cream
    },
    drawerId: {
      hover: 'rgba(238, 239, 233, 0.12)',
      main: 'rgba(238, 239, 233, 0.07)',
      contrastText: obi.cream
    },
    drawerNav: {
      hover: 'rgba(99, 182, 220, 0.16)',
      main: 'rgba(99, 182, 220, 0.10)',
      accent: '#63B6DC',
      contrastText: obi.cream
    },
    drawerLogo: {
      main: obi.cream,
    },
    orange: {
      main: obi.yellow,
      contrastText: obi.ink,
    },
    success: {
      main: '#388e3c',
      dark: '#328036',
      darker: '#2d7230',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: '#323232',
      default: '#242424',

      contrastText: obi.cream
    },
    text: {
      primary: obi.cream,
      secondary: obi.border,
      disabled: obi.muted,
    },
    divider: '#484848',
  },
});
